module.exports = __webpack_public_path__ + "img/trevi_logo.86726aea.png";